import React, { Component, Fragment } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { observer, Provider } from 'mobx-react'

import 'libs/widget' // order import is important (I18n should be always on the top)

import ErrorBoundary from 'ui/error-boundary/ErrorBoundary'

import { I18nProvider } from '@elo-kit/components'

import stores from './stores'
import Routes from './routes'

import '../../../styles/widget.scss'

@observer
class Widget extends Component {
  render() {
    return (
      <I18nProvider>
        <Provider {...stores}>
          <Router>
            <Fragment>
              <div id='wrapper'>
                <Routes />
              </div>
            </Fragment>
          </Router>
        </Provider>
      </I18nProvider>
    )
  }
}

const root = createRoot(document.getElementById('root'))

root.render(
  <ErrorBoundary>
    <Widget />
  </ErrorBoundary>
)
